import { Button } from "../../../forms/Button";
import { MAX_DISCUSSION_LENGTH } from "../../useDiscussionsPanel";

export interface DiscussionTextInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  saveLabel?: string;
  maxLength?: number;
}

export const DiscussionTextInput = ({
  value,
  placeholder,
  onChange,
  onSave,
  onCancel,
  saveLabel = "Save",
  maxLength = MAX_DISCUSSION_LENGTH,
}: DiscussionTextInputProps): JSX.Element => {
  const overLimit = value.length > maxLength;
  const nearLimit = !overLimit && maxLength - value.length <= 50;
  let counterSuffix = "";
  if (overLimit) counterSuffix = " DiscussionTextInput_counterError";
  else if (nearLimit) counterSuffix = " DiscussionTextInput_counterNear";

  return (
    <div className="DiscussionTextInput">
      <textarea
        className={`DiscussionTextInput__area${overLimit ? " DiscussionTextInput_areaError" : ""}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value.length > 0 && (
        <div className="DiscussionTextInput_meta">
          <span className={`DiscussionTextInput_counter${counterSuffix}`}>
            {value.length}/{maxLength}
          </span>
        </div>
      )}
      <div className="DiscussionTextInput__buttons">
        <Button variant="primary" size="small" text={saveLabel} onClick={onSave} disabled={overLimit} />
        <Button variant="tertiary" size="small" text="Cancel" onClick={onCancel} />
      </div>
    </div>
  );
};
